<div class="approval-progress-container">
  @if (!shouldShowSpinner) {
    <div class="status-label">
      {{ statusText }}
    </div>
  }

  @if (shouldShowSpinner) {
    <div class="progress-with-status">
      <div class="status-label">
        {{ statusText }}
      </div>
      <div class="progress-spinner-container">
        <div class="spinner-wrapper">
          <mat-progress-spinner class="spinner track" mode="determinate" [value]="100" [diameter]="32" [strokeWidth]="3">
          </mat-progress-spinner>
          <mat-progress-spinner class="spinner value" mode="determinate" [value]="progressValue" [diameter]="32"
            [strokeWidth]="3">
          </mat-progress-spinner>
          <div class="progress-text">
            {{ progressText }}
          </div>
        </div>
      </div>
    </div>
  }
</div>